import React, { useEffect, useState } from "react";
import { api } from "../utils/api";
import { useToast } from "@forge/ui";

type Props = {
  initialDate?: string;
  initialTime?: string;
  onBooked?: () => void;
};

async function postBooking(payload: {
  date: string;
  time: string;
  notes?: string;
}) {
  return api.post<unknown>("/api/user/bookings", payload);
}

const BookingForm: React.FC<Props> = ({
  initialDate,
  initialTime,
  onBooked,
}) => {
  const [date, setDate] = useState<string>(initialDate || "");
  const [time, setTime] = useState<string>(initialTime || "");
  const [notes, setNotes] = useState<string>("");
  const [submitting, setSubmitting] = useState(false);
  const { show } = useToast();
  useEffect(() => {
    // intentionally mount-only: initialDate/initialTime are seed values from
    // a parent slot picker; re-running on later prop changes would clobber
    // user edits to the form fields.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    if (initialDate) setDate(initialDate);
    if (initialTime) setTime(initialTime);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!date || !time) return;
    setSubmitting(true);
    try {
      await postBooking({ date, time, notes });
      setNotes("");

      if (onBooked) onBooked();
    } catch (err) {
      show(err instanceof Error ? err.message : "Booking failed", "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="fp-booking-form" onSubmit={handleSubmit}>
      <h2>Book a session</h2>
      <div className="fp-form-row">
        <label>Date</label>
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          required
        />
      </div>
      <div className="fp-form-row">
        <label>Time</label>
        <input
          type="time"
          value={time}
          onChange={(e) => setTime(e.target.value)}
          required
        />
      </div>
      <div className="fp-form-row">
        <label>Notes</label>
        <textarea
          placeholder="Anything you'd like the trainer to know?"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
      </div>
      <div className="fp-form-actions">
        <button type="submit" disabled={submitting} className="cta">
          {submitting ? "Booking..." : "Book Session"}
        </button>
      </div>
      <div className="fp-policy">
        Policy: You can cancel up to 24 hours before a session.
      </div>
    </form>
  );
};

export default BookingForm;
